import { Link } from "react-router-dom";
import { Heart, Mail, Phone, MapPin } from "lucide-react";

const LOGO_URL = "https://customer-assets.emergentagent.com/job_928e083d-76f5-471c-8405-fe8d0803371a/artifacts/i09y221l_BSM%20Welfare%20LOGO%202%20%281%29.png";

const quickLinks = [
  { name: "Home", path: "/" },
  { name: "About Us", path: "/about" },
  { name: "Focus Areas", path: "/focus-areas" },
  { name: "Programs", path: "/programs" },
];

const involveLinks = [
  { name: "Volunteer", path: "/get-involved" },
  { name: "Partner With Us", path: "/get-involved" },
  { name: "CSR Collaboration", path: "/get-involved" },
  { name: "Donate", path: "/get-involved" },
];

const legalLinks = [
  { name: "Governance", path: "/governance" },
  { name: "Transparency", path: "/governance" },
  { name: "Updates", path: "/updates" },
  { name: "Contact", path: "/contact" },
];

export default function Footer() {
  return (
    <footer data-testid="main-footer" className="bg-[#1B201E] text-white">
      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12 py-16 sm:py-20">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 lg:gap-8">
          {/* Brand */}
          <div className="lg:col-span-1">
            <Link to="/" className="inline-block mb-5">
              <img src={LOGO_URL} alt="BSM Welfare Foundation" className="h-14 w-auto brightness-0 invert" />
            </Link>
            <p className="text-[#7A827E] text-sm leading-relaxed mb-6">
              Building a Spiritually Aware and Socially Empowered Society. From Awareness to Action.
            </p>
            <div className="flex items-center gap-2 text-sm text-[#7A827E]">
              <Heart size={14} className="text-[#E28743]" />
              <span>Section 8 Company (Non-Profit)</span>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-['Outfit'] font-semibold text-base mb-5">Quick Links</h4>
            <ul className="space-y-3">
              {quickLinks.map((link) => (
                <li key={link.name}>
                  <Link
                    to={link.path}
                    className="text-sm text-[#7A827E] hover:text-[#E28743] transition-colors duration-200"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Get Involved */}
          <div>
            <h4 className="font-['Outfit'] font-semibold text-base mb-5">Get Involved</h4>
            <ul className="space-y-3">
              {involveLinks.map((link, i) => (
                <li key={i}>
                  <Link
                    to={link.path}
                    className="text-sm text-[#7A827E] hover:text-[#E28743] transition-colors duration-200"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-['Outfit'] font-semibold text-base mb-5">Contact</h4>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <Mail size={16} className="text-[#E28743] mt-0.5 shrink-0" />
                <span className="text-sm text-[#7A827E]">contact@bsmwelfare.org</span>
              </li>
              <li className="flex items-start gap-3">
                <Phone size={16} className="text-[#E28743] mt-0.5 shrink-0" />
                <span className="text-sm text-[#7A827E]">+91 XXXXX XXXXX</span>
              </li>
              <li className="flex items-start gap-3">
                <MapPin size={16} className="text-[#E28743] mt-0.5 shrink-0" />
                <span className="text-sm text-[#7A827E]">New Delhi, India</span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="mt-14 pt-8 border-t border-white/10 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-[#7A827E]">
            &copy; {new Date().getFullYear()} BSM Welfare Foundation. All rights reserved.
          </p>
          <div className="flex gap-6">
            {legalLinks.map((link, i) => (
              <Link
                key={i}
                to={link.path}
                className="text-xs text-[#7A827E] hover:text-[#E28743] transition-colors"
              >
                {link.name}
              </Link>
            ))}
          </div>
        </div>
      </div>
    </footer>
  );
}
